"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressChangeDeclineTextOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var PremiumOutputWidget_1 = require("../subscription/PremiumOutputWidget");
var AddressChangeDeclineTextOutputWidget = /** @class */ (function (_super) {
    __extends(AddressChangeDeclineTextOutputWidget, _super);
    function AddressChangeDeclineTextOutputWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.declineTextToDisplay = function () {
            var failedRules = _this.props.interaction.underwritingResult.map(function (underwritingResult) { return underwritingResult.objectName; });
            var rentersUWFailed = failedRules.some(function (rule) { return rule.includes("UR"); });
            var motorUWFailed = failedRules.some(function (rule) { return rule.includes("UW"); });
            var userIsMovedToNewAddress = _this.props.interaction.policyHolder.movedToAddress;
            var displayMessage = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            if (rentersUWFailed && !motorUWFailed && userIsMovedToNewAddress) {
                displayMessage = (0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("p", { children: "Sorry, we can\u2019t continue your renters cover at your new address. Because you said that you already moved, we will cancel your renters cover in 1 day time." }) });
            }
            else if (!rentersUWFailed && motorUWFailed && userIsMovedToNewAddress) {
                displayMessage = (0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("p", { children: "Sorry, we can\u2019t continue your car(s) cover at your new address. Because you said that you already moved, we will cancel your car(s) cover in 7 days time." }) });
            }
            else if (rentersUWFailed && !motorUWFailed && !userIsMovedToNewAddress) {
                displayMessage = (0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("p", { children: "Sorry, we can\u2019t continue your renters cover at your new address. We will cancel your renters cover in 1 day time from the date you selected." }) });
            }
            else if (!rentersUWFailed && motorUWFailed && !userIsMovedToNewAddress) {
                displayMessage = (0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("p", { children: "Sorry, we can\u2019t continue your car(s) cover at your new address. We will cancel your car(s) cover in 7 days time from the date you selected." }) });
            }
            else if (rentersUWFailed && motorUWFailed && userIsMovedToNewAddress) {
                displayMessage = (0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("p", { children: "Sorry, we can't cover you at your new address. Because you said that you already moved, we will cancel your cover in 7 days time." }) });
            }
            else if (rentersUWFailed && motorUWFailed && !userIsMovedToNewAddress) {
                displayMessage = (0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("p", { children: "Sorry, we can't cover you at your new address. We will cancel your cover in 7 days time from the date you selected." }) });
            }
            return displayMessage;
        };
        return _this;
    }
    AddressChangeDeclineTextOutputWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("div", { className: "panel text-center", children: this.declineTextToDisplay() }));
    };
    return AddressChangeDeclineTextOutputWidget;
}(PremiumOutputWidget_1.PremiumOutputWidget));
exports.AddressChangeDeclineTextOutputWidget = AddressChangeDeclineTextOutputWidget;
//# sourceMappingURL=AddressChangeDeclineTextOutputWidget.js.map